import { analytics } from '@/plugins/analytics';

export default {
  beforeMount(el, binding, vnode) {
    const { value } = binding;

    if (!value || typeof value !== 'object') {
      return;
    }

    const handleClick = _event => {
      if (!analytics || !analytics.canTrack()) {
        return;
      }

      let currentRoute = null;

      const app = vnode.appContext?.app;
      const router = app?.config?.globalProperties?.$router;
      if (router?.currentRoute?.value) {
        currentRoute = router.currentRoute.value;
      }

      if (!currentRoute) {
        const path = window.location.pathname + window.location.search + window.location.hash;
        currentRoute = { name: path.split('/').pop() || 'unknown', meta: {}, path };
      }

      const trackingData = {
        element_label: value.element_label || value.label || 'Unknown',
        screen_name: currentRoute?.name || window.location.pathname.split('/').pop() || 'unknown',
        screen_group: currentRoute?.meta?.group || '',
        ...value,
      };

      analytics.event('ui_click', trackingData);

      if (value.action && value.entity) {
        const actionData = {
          action: value.action,
          entity: value.entity,
          entity_id: value.entity_id || '',
          screen_name: currentRoute?.name || window.location.pathname.split('/').pop() || 'unknown',
          ...value,
        };

        analytics.event('action_performed', actionData);
      }
    };

    el._trackClickHandler = handleClick;
    el.addEventListener('click', handleClick);
  },

  unmounted(el) {
    if (el._trackClickHandler) {
      el.removeEventListener('click', el._trackClickHandler);
      delete el._trackClickHandler;
    }
  },
};
